/* NUMY front-end. Dual-mode cart + page interactions.
   Theme mode (window.NM_THEME): native Shopify cart AJAX.
   Static preview: a local demo cart (localStorage) so the whole flow can be exercised before the store exists. */
(function () {
  "use strict";

  var THEME = !!window.NM_THEME;
  var ASSET = window.NM_ASSET_BASE || "assets/";
  var VIDEO = window.NM_VIDEO_BASE || "video/";
  var TIERS = window.NM_TIERS || [];
  var money = function (v) { return "$" + (Math.round(v * 100) / 100).toFixed(2); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var byHandle = {};
  TIERS.forEach(function (t) { byHandle[t.handle] = t; });

  // ---------------------------------------------------------- cart backends
  var cart = null; // { lines: [{lineId, qty, handle, title, price, orig}] }

  var backend;
  if (THEME) {
    var json = function (url, body) {
      return fetch(url, { method: body ? "POST" : "GET", headers: { "Content-Type": "application/json" }, body: body ? JSON.stringify(body) : undefined })
        .then(function (r) { if (!r.ok) throw new Error("cart " + r.status); return r.json(); });
    };
    var map = function (c) {
      return { lines: (c.items || []).map(function (it) {
        var t = byHandle[it.handle];
        return { lineId: String(it.key), qty: it.quantity, handle: it.handle, title: it.product_title,
                 price: it.price / 100, orig: t ? t.orig : (it.original_price / 100),
                 variantId: it.variant_id, image: it.image };
      }) };
    };
    backend = {
      load: function () { return json("/cart.js").then(map); },
      add: function (handle, qty) {
        var p = window.NM_PRODUCTS && window.NM_PRODUCTS[handle];
        if (!p) return Promise.reject(new Error("product not in store: " + handle));
        return json("/cart/add.js", { items: [{ id: p.variants[0].id, quantity: qty || 1 }] }).then(function () { return json("/cart.js").then(map); });
      },
      change: function (lineId, qty) { return json("/cart/change.js", { id: lineId, quantity: qty }).then(map); },
      checkout: function () { window.location.href = "/checkout"; }
    };
  } else {
    var KEY = "nmDemoCart";
    var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; } };
    var write = function (l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} return { lines: l }; };
    backend = {
      load: function () { return Promise.resolve({ lines: read() }); },
      add: function (handle, qty) {
        var l = read(), t = byHandle[handle], hit = l.filter(function (x) { return x.handle === handle; })[0];
        if (hit) hit.qty += qty || 1;
        else l.push({ lineId: handle, qty: qty || 1, handle: handle, title: t.name, price: t.price, orig: t.orig });
        return Promise.resolve(write(l));
      },
      change: function (lineId, qty) {
        var l = read().map(function (x) { if (x.lineId === lineId) x.qty = qty; return x; }).filter(function (x) { return x.qty > 0; });
        return Promise.resolve(write(l));
      },
      checkout: function () {
        var n = $("[data-cart-checkout]");
        n.textContent = "Checkout connects when the store goes live";
        n.disabled = true;
      }
    };
  }

  function imgFor(line) {
    if (line.image) return line.image;
    var t = byHandle[line.handle];
    return ASSET + (t ? t.img : "nm-bold") + "-480.webp";
  }

  // ---------------------------------------------------------- cart UI
  function renderCart() {
    var root = $("[data-cart]");
    if (!root) return;
    var lines = cart ? cart.lines : [];
    var count = lines.reduce(function (a, l) { return a + l.qty; }, 0);
    var badge = $("[data-cart-count]");
    if (badge) { badge.textContent = count; badge.hidden = count === 0; }
    $("[data-cart-empty]").hidden = count > 0;
    $("[data-cart-foot]").hidden = count === 0;

    var box = $("[data-cart-lines]");
    box.innerHTML = "";
    lines.forEach(function (l) {
      var t = byHandle[l.handle];
      var row = document.createElement("div");
      row.className = "nm-line";
      row.innerHTML =
        '<img src="' + imgFor(l) + '" width="64" height="64" alt="">' +
        '<span><span class="nm-line__t">' + (t ? t.name : l.title) + "</span>" +
        (t ? '<span class="nm-line__v">' + t.items.join(" + ") + "</span>" : "") +
        '<span class="nm-line__qty"><button type="button" data-dec aria-label="Decrease">&minus;</button><span>' + l.qty + '</span><button type="button" data-inc aria-label="Increase">+</button></span></span>' +
        '<span><span class="nm-line__p">' + money(l.price * l.qty) + '</span><button class="nm-line__rm" type="button" data-rm>Remove</button></span>';
      row.querySelector("[data-inc]").addEventListener("click", function () { changeQty(l, l.qty + 1); });
      row.querySelector("[data-dec]").addEventListener("click", function () { changeQty(l, l.qty - 1); });
      row.querySelector("[data-rm]").addEventListener("click", function () { changeQty(l, 0); });
      box.appendChild(row);
    });

    // one-tap upgrade: Bold alone in the cart -> offer the bundle rows that are not in the cart
    var upsellBox = $("[data-cart-addons]");
    var inCart = {};
    lines.forEach(function (l) { inCart[l.handle] = true; });
    var offers = [];
    if (inCart["numy-bold"] && !inCart["numy-best-seller-bundle"] && !inCart["numy-self-love-bundle"]) {
      offers = TIERS.filter(function (t) { return t.handle !== "numy-bold"; });
    }
    upsellBox.hidden = !(count > 0 && offers.length);
    $("[data-cart-addon-list]").innerHTML = offers.map(function (u) {
      return '<div class="nm-cart__addonrow"><img src="' + ASSET + u.img + '-480.webp" alt=""><span><b>Switch to the ' + u.name + "</b>" + money(u.price) + " &middot; save " + money(u.orig - u.price) + '</span><button type="button" data-upsell="' + u.handle + '">Switch</button></div>';
    }).join("");
    $$("[data-upsell]", upsellBox).forEach(function (btn) {
      btn.addEventListener("click", function () {
        busy(btn, true);
        var bold = lines.filter(function (l) { return l.handle === "numy-bold"; })[0];
        backend.change(bold.lineId, 0).then(function () { return backend.add(btn.getAttribute("data-upsell"), 1); })
          .then(function (c) { cart = c; renderCart(); });
      });
    });

    var subtotal = lines.reduce(function (a, l) { return a + l.price * l.qty; }, 0);
    var savings = lines.reduce(function (a, l) { return a + Math.max(0, (l.orig || l.price) - l.price) * l.qty; }, 0);
    $("[data-cart-savings]").hidden = savings === 0;
    if (savings) $("[data-cart-savings-amt]").textContent = "−" + money(savings);
    $("[data-cart-subtotal]").textContent = money(subtotal);
  }

  function busy(el, on) { el.disabled = on; el.style.opacity = on ? ".5" : ""; }

  function changeQty(line, qty) {
    backend.change(line.lineId, qty).then(function (c) { cart = c; renderCart(); });
  }

  function openCart() {
    var root = $("[data-cart]");
    if (!root) return;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add("is-open"); });
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    var root = $("[data-cart]");
    if (!root) return;
    root.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () { root.hidden = true; }, 300);
  }

  // ---------------------------------------------------------- drawers
  function wire(openSel, closeSel, openFn, closeFn, rootSel) {
    $$(openSel).forEach(function (b) { b.addEventListener("click", openFn); });
    var root = $(rootSel);
    if (root) $$(closeSel, root).forEach(function (b) { b.addEventListener("click", closeFn); });
  }
  function openMenu() {
    var d = $("[data-drawer]");
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add("is-open"); });
    document.body.style.overflow = "hidden";
  }
  function closeMenu() {
    var d = $("[data-drawer]");
    d.classList.remove("is-open");
    document.body.style.overflow = "";
    setTimeout(function () { d.hidden = true; }, 300);
  }
  wire("[data-drawer-open]", "[data-drawer-close]", openMenu, closeMenu, "[data-drawer]");
  wire("[data-cart-open]", "[data-cart-close]", openCart, closeCart, "[data-cart]");
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeMenu(); closeCart(); } });
  var co = $("[data-cart-checkout]");
  if (co) co.addEventListener("click", function () { backend.checkout(); });

  // ---------------------------------------------------------- reveal
  if (document.documentElement.className.indexOf("js-anim") !== -1 && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -6% 0px" });
    $$(".nm-rise").forEach(function (el) { io.observe(el); });
  } else {
    $$(".nm-rise").forEach(function (el) { el.classList.add("is-in"); });
  }

  // ---------------------------------------------------------- video rails
  var vids = $$("[data-vid]");
  if (vids.length) {
    var posterFor = function (fig) {
      var v = $("video", fig);
      if (v && !v.poster && v.getAttribute("data-poster")) v.poster = v.getAttribute("data-poster");
    };
    var loadVid = function (fig) {
      var v = $("video", fig);
      posterFor(fig);
      if (!v || v.getAttribute("src")) return;
      var src = v.getAttribute("data-src");
      v.src = THEME ? src : src; // theme build rewrites data-src to the Files CDN URL
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    if ("IntersectionObserver" in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = $("video", en.target);
          if (en.isIntersecting) loadVid(en.target);
          else if (v && !en.target.classList.contains("is-sound") && !v.paused) v.pause();
          if (en.isIntersecting && v && v.paused && v.getAttribute("src")) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
      }, { rootMargin: "200px 0px" });
      vids.forEach(function (f) { vio.observe(f); });
      var pio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { posterFor(en.target); pio.unobserve(en.target); } });
      }, { rootMargin: "700px 0px" });
      vids.forEach(function (f) { pio.observe(f); });
    } else {
      vids.forEach(loadVid);
    }
    var soundOff = function () {
      vids.forEach(function (f) { f.classList.remove("is-sound"); var v = $("video", f); if (v) v.muted = true; });
    };
    vids.forEach(function (fig) {
      var v = $("video", fig);
      var toggle = function (e) {
        e.preventDefault();
        var on = fig.classList.contains("is-sound");
        soundOff();
        if (!on) {
          loadVid(fig);
          v.muted = false; v.currentTime = 0;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          fig.classList.add("is-sound");
        }
      };
      $("[data-vid-sound]", fig).addEventListener("click", toggle);
      v.addEventListener("click", toggle);
    });
  }

  // ---------------------------------------------------------- setting demo
  var demo = $("[data-demo]");
  if (demo) {
    var mode = 0, intensity = 3;
    var wave = $("[data-wave]", demo), wave2 = $("[data-wave2]", demo);
    var reads = [
      "Slow, even waves. Where most women start.",
      "Short pulses with a breath between.",
      "Rises, holds, falls away. Like a tide.",
      "Builds a little more each cycle.",
      "A steady double beat.",
      "Small ripples that gather into one.",
      "Long swells, no gaps.",
      "Quick surges, then calm.",
      "Barely there, then not.",
      "Deep and constant. Nothing else."
    ];
    var fn = function (m, x) { // x 0..1 -> -1..1
      var t = x * Math.PI * 2;
      switch (m) {
        case 0: return Math.sin(t * 2);
        case 1: return Math.sin(t * 6) > .3 ? Math.sin(t * 24) : 0;
        case 2: return Math.sin(t) * Math.sin(t * 8);
        case 3: return x * Math.sin(t * 10);
        case 4: { var b = (x * 3) % 1; return (b < .12 ? Math.sin(b / .12 * Math.PI) : b > .2 && b < .32 ? .7 * Math.sin((b - .2) / .12 * Math.PI) : 0) * Math.sin(t * 40); }
        case 5: return Math.sin(t * 3) * Math.sin(t * 14) * (0.5 + 0.5 * x);
        case 6: return Math.sin(t * 1.5) * Math.sin(t * 6);
        case 7: return Math.abs(Math.sin(t * 4)) > .6 ? Math.sin(t * 30) : .1 * Math.sin(t * 30);
        case 8: return Math.sin(t * 4) * (0.35 + 0.65 * Math.abs(Math.sin(t * 0.5)));
        default: return Math.sin(t * 16);
      }
    };
    var draw = function () {
      var amp = 10 + intensity * 6.4, N = 160, d = "", d2 = "";
      for (var i = 0; i <= N; i++) {
        var x = i / N, y = 80 - fn(mode, x) * amp, y2 = 80 + fn(mode, (x + .08) % 1) * amp * .6;
        d += (i ? " L" : "M") + (x * 600).toFixed(1) + " " + y.toFixed(1);
        d2 += (i ? " L" : "M") + (x * 600).toFixed(1) + " " + y2.toFixed(1);
      }
      wave.setAttribute("d", d); wave2.setAttribute("d", d2);
      $("[data-int-val]", demo).textContent = intensity;
      $("[data-demo-read]", demo).textContent = reads[mode];
    };
    $$("[data-mode]", demo).forEach(function (b) {
      b.addEventListener("click", function () {
        $$("[data-mode]", demo).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        b.setAttribute("aria-pressed", "true");
        mode = +b.getAttribute("data-mode"); draw();
      });
    });
    $("[data-int]", demo).addEventListener("input", function (e) { intensity = +e.target.value; draw(); });
    draw();
  }

  // ---------------------------------------------------------- PDP
  var buy = $("[data-buy]");
  if (buy) {
    document.body.classList.add("nm-has-sticky");
    function selectedTier() {
      var r = $("[data-tier]:checked");
      return TIERS[r ? +r.value : 1];
    }
    function showImg(i) {
      $$("[data-gal-img]").forEach(function (im) { im.hidden = im.getAttribute("data-gal-img") !== String(i); });
      $$("[data-gal-thumb]").forEach(function (t) { t.setAttribute("aria-selected", String(t.getAttribute("data-gal-thumb") === String(i))); });
    }
    function updatePrice() {
      var t = selectedTier();
      $("[data-cta-price]").textContent = money(t.price);
      var sp = $("[data-sticky-price]"); if (sp) sp.textContent = money(t.price);
      var sn = $("[data-sticky-name]"); if (sn) sn.textContent = t.name;
    }
    $$("[data-gal-thumb]").forEach(function (t) { t.addEventListener("click", function () { showImg(t.getAttribute("data-gal-thumb")); }); });
    $$("[data-tier]").forEach(function (r) { r.addEventListener("change", updatePrice); });
    try {
      var qt = parseInt(new URLSearchParams(location.search).get("tier") || "", 10);
      if (qt >= 0 && qt < TIERS.length) { var radio = $('[data-tier][value="' + qt + '"]'); if (radio) radio.checked = true; }
    } catch (e) {}
    if (window.NM_INIT_TIER !== undefined) { var r0 = $('[data-tier][value="' + window.NM_INIT_TIER + '"]'); if (r0) r0.checked = true; }
    updatePrice();

    function addToCart() {
      var btn = $("[data-add-to-cart]");
      var err = $("[data-cart-error]");
      err.hidden = true;
      busy(btn, true);
      backend.add(selectedTier().handle, 1).then(function (c) {
        cart = c; busy(btn, false); renderCart(); openCart();
      }).catch(function () {
        busy(btn, false);
        err.textContent = "Could not reach the store just now. Give it a second and try again.";
        err.hidden = false;
      });
    }
    $("[data-add-to-cart]").addEventListener("click", addToCart);
    var sg = $("[data-sticky-go]");
    if (sg) sg.addEventListener("click", addToCart);
    // hide the sticky bar while the real button is on screen
    var cta = $("[data-add-to-cart]"), sticky = $("[data-sticky]");
    if (cta && sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { sticky.style.display = en[0].isIntersecting ? "none" : ""; }).observe(cta);
    }
  }

  // ---------------------------------------------------------- load cart
  backend.load().then(function (c) { cart = c; renderCart(); }).catch(function () {});

  // ---------------------------------------------------------- forms (preview only; theme swaps in Shopify forms)
  function wireCapture(formSel, noteSel) {
    var f = $(formSel);
    if (!f) return;
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = f.querySelector("input[type=email]"), note = $(noteSel);
      if (!input.value || input.value.indexOf("@") === -1) { note.textContent = "That email looks off. One more try?"; note.hidden = false; return; }
      try { var list = JSON.parse(localStorage.getItem("nmList") || "[]"); list.push({ email: input.value, at: new Date().toISOString() }); localStorage.setItem("nmList", JSON.stringify(list)); } catch (err) {}
      note.textContent = "You're on the list. Talk soon."; note.hidden = false; input.value = "";
    });
  }
  wireCapture("[data-capture]", "[data-capture-note]");
  wireCapture("[data-capture-2]", "[data-capture-2-note]");
  var contact = $("[data-contact]");
  if (contact) {
    contact.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(contact), note = $("[data-contact-note]");
      if (!fd.get("name") || !fd.get("email") || !fd.get("message")) { note.textContent = "Fill in your name, email and message and we take it from there."; note.hidden = false; return; }
      note.textContent = "Message saved for the preview. The live store sends this through Shopify's contact form."; note.hidden = false;
    });
  }
})();
